import { ACCOUNT_RECEIVED } from '../action-list';

export default function(state = {}, action) {
  switch (action.type) {
    case ACCOUNT_RECEIVED:
      return action.payload;

    default:
      return state;
  }
}
